import { useFetchAuthenticate } from "hooks";
import { getURLWithParams } from "utils/context";

export const useBlogs = (params = {}) =>
  useFetchAuthenticate(getURLWithParams("/blog", params));
